import axios from "axios";
import { Constants } from "../utils/Constants";

export function login(email, password, captchaToken) {
  return axios.post(
    `${Constants.url}/auth/login`,
    { email, password, captchaToken },
    { _isAuthRoute: true }
  );
}

export function me() {
  return axios.get(`${Constants.url}/auth/me`, { _isAuthRoute: true });
}

export function refresh() {
  return axios.post(`${Constants.url}/auth/refresh`, null, {
    _isAuthRoute: true,
  });
}

export function verifyMfaLogin(sid, code) {
  return axios.post(
    `${Constants.url}/auth/mfa/verify`,
    { sid, code },
    { _isAuthRoute: true }
  );
}

export function logout() {
  return axios.post(`${Constants.url}/auth/logout`, null, {
    _isAuthRoute: true,
  });
}

export function forgot(email, captchaToken) {
  return axios.post(`${Constants.url}/auth/password/forgot`, {
    email,
    captchaToken,
  });
}

export function reset(token, password) {
  return axios.post(`${Constants.url}/auth/password/reset`, {
    token,
    password,
  });
}

export function getMfaStatus() {
  return axios.get(`${Constants.url}/auth/mfa/status`);
}

export function getMfaMethods(sid) {
  const params = sid ? `?sid=${sid}` : "";
  return axios.get(`${Constants.url}/auth/mfa/methods${params}`);
}

export function setupMfa() {
  return axios.post(`${Constants.url}/auth/mfa/setup`);
}

export function enableMfa(code) {
  return axios.post(`${Constants.url}/auth/mfa/enable`, { code });
}

export function disableMfa(password) {
  return axios.post(`${Constants.url}/auth/mfa/disable`, { password });
}

export function regenerateBackupCodes(password) {
  return axios.post(`${Constants.url}/auth/mfa/backup-codes`, { password });
}

export function verifyStepUp(code, bucket = "security") {
  return axios.post(`${Constants.url}/auth/mfa/step-up/verify`, {
    code,
    bucket,
  });
}

export function changePassword(currentPassword, newPassword) {
  return axios.post(`${Constants.url}/auth/password/change`, {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

export function getSessions() {
  return axios.get(`${Constants.url}/auth/sessions`);
}

export function revokeSession(sessionId) {
  return axios.delete(`${Constants.url}/auth/sessions/${sessionId}`);
}

export function revokeAllOtherSessions() {
  return axios.delete(`${Constants.url}/auth/sessions`);
}

export function forceResetPassword(userId, password) {
  return axios.post(`${Constants.url}/auth/password/force-reset/${userId}`, {
    password,
  });
}

export function forceResetAdminPassword(adminId, password) {
  return axios.post(`${Constants.url}/auth/password/force-reset/admin/${adminId}`, {
    password,
  });
}
